/**
 * 北斗埋点
 */
import { loadScript } from "../../utils"
import project from "../../../package.json"
declare const window: any

const init = () => {
  // 异步加载CDN的方式引入北斗埋点SDK
  loadScript("//res.huizecdn.com/beidou-js-sdk-v2/index.v2.min.js").then(() => {
    const { BeidouDatadynamicInject } = window
    if (!BeidouDatadynamicInject) {
      return
    }
    const { init } = BeidouDatadynamicInject || {}
    const beidouInstance = init({
      app_id: "71faa02d39a448a9ba20c616fe9f339f",
      app_version: project.version,
      show_log: localStorage.getItem("showlog") === "true",
      is_track_single_page: true,
      heatmap: {
        clickmap: "default",
        scroll_notice_map: "default",
      },
    })

    beidouInstance.quick("autoTrack")
  })
}

export default init
